import Vue from 'vue'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select'
import { Datetime } from 'vue-datetime'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import store from './store'

import './custom.css'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import {
  faUser, faEdit, faFileMedicalAlt, faInfoCircle, faMinusCircle, faSearch, faMinus, faPlus, faBroom, faPaintBrush, faCog, faKey,
  faImage, faSpinner
} from '@fortawesome/free-solid-svg-icons'

import Default from "@/layouts/Default"
import Dashboard from '@/layouts/Dashboard'
import Login from '@/layouts/Login'
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(Datetime)
Vue.use(require('vue-moment'), { moment })
Vue.use(Loading)
Vue.component('datetime', Datetime);
Vue.component('v-select', vSelect)
library.add(faUser, faFileMedicalAlt, faInfoCircle, faEdit, faMinusCircle, faSearch, faMinus, faPlus, faPaintBrush, faKey,
  faImage, faSpinner)
Vue.component('font-awesome-icon', FontAwesomeIcon)

//Layout
Vue.component('login-layout', Login)
Vue.component('default-layout', Default)
Vue.component('dashboard-layout', Dashboard)

//Global Variables
Vue.prototype.$URI_OHIF = "https://labviewer.easyview.com.co/viewer"
Vue.prototype.$apiURI_study = "https://labstudy.easyview.com.co"
Vue.prototype.$apiURI_users = "https://labuser.easyview.com.co"
Vue.prototype.$title_application = "EasyViewLab"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  methods: {
    showMessage(message, title, color) {
      title = title != null ? title : "!";
      color = color != null ? color : "danger";
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 3000,
        variant: color
      });
    }
  },
  created: function () {
    const left = this;
    var statusToken = true;

    this.axios.interceptors.request.use(
      function (config) {
        const jwt_value = left.$store.state.accessToken;
        if (jwt_value != null) {
          config.headers['Authorization'] = 'Bearer ' + jwt_value;
          document.getElementById("overlay").style.display = "block";
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    this.axios.interceptors.response.use(
      function (response) {
        document.getElementById("overlay").style.display = "none";
        const jwt_value = left.$store.state.accessToken;      
        
        if (jwt_value != null && statusToken) {                   
          if ((left.$store.getters.timeExpiredToken - Date.now() / 1000) <= 60) {         
            statusToken = false;
            left.axios
              .post(left.$apiURI_users + "/api/v1/users/refresh")
              .then(response => {                
                left.$store.dispatch("updateToken", response.data.token);
                statusToken = true;
              });
          }
        }
        return response;
      },
      function (error) {        
        if (error.response.status === 400) {
          if (typeof error.response.data.message !== 'undefined') {
            left.showMessage(error.response.data.message, null, null)
          } else {
            left.showMessage("No se puede realizar la petición", null, null)
          }
        } else if (error.response.status === 401) {
          if (typeof error.response.data.message !== 'undefined') {
            left.showMessage(error.response.data.message, null, null)
          }
          left.$store.dispatch("logoutUser");
          left.$router.push("/login")
        } else if (error.response.status === 404) {
          if (typeof error.response.data.warning !== 'undefined') {
            left.showMessage(error.response.data.warning, null, null)
          } else {
            left.showMessage("No se encuentra el recurso", null, null)
          }
        } else if (error.response.status === 500) {
          left.showMessage("Ocurrio un error interno al realizar la acción", "! Ups", null)
        }
        return Promise.reject(error);
      }
    );
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js